import { useNavigate } from "react-router-dom";

export default function ThankYouPage() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-olive-50 flex flex-col items-center justify-center px-4 text-center">
      <div className="w-20 h-20 flex items-center justify-center bg-olive-100 rounded-full text-olive-500 text-3xl mb-6">
        <i className="fas fa-check"></i>
      </div>
      <h1 className="font-heading text-4xl md:text-5xl font-bold text-olive-900 mb-4">
        You're All Set!
      </h1>
      <p className="text-olive-600 text-lg max-w-md mb-8 leading-relaxed">
        Your consultation is booked. Carol is excited to chat with you and help
        your family find the path that fits best.
      </p>
      <div className="bg-white rounded-2xl border border-olive-100 p-8 max-w-md w-full mb-8">
        <h3 className="font-heading text-lg font-bold text-olive-800 mb-4">
          What happens next?
        </h3>
        <ul className="space-y-3 text-left text-sm text-olive-700">
          <li className="flex items-start gap-3">
            <span className="mt-0.5 w-5 h-5 flex items-center justify-center bg-olive-100 text-olive-600 rounded-full text-xs font-bold shrink-0">
              1
            </span>
            Check your email for a calendar invite and Zoom link.
          </li>
          <li className="flex items-start gap-3">
            <span className="mt-0.5 w-5 h-5 flex items-center justify-center bg-olive-100 text-olive-600 rounded-full text-xs font-bold shrink-0">
              2
            </span>
            Come with your questions — no pressure, just a friendly chat.
          </li>
          <li className="flex items-start gap-3">
            <span className="mt-0.5 w-5 h-5 flex items-center justify-center bg-olive-100 text-olive-600 rounded-full text-xs font-bold shrink-0">
              3
            </span>
            Walk away with a clear next step for your family.
          </li>
        </ul>
      </div>
      <button
        onClick={() => navigate("/")}
        className="whitespace-nowrap inline-flex items-center gap-2 bg-olive-500 hover:bg-olive-600 text-white font-semibold px-8 py-3.5 rounded-full text-base transition-all hover:scale-105 cursor-pointer"
      >
        <span className="w-4 h-4 flex items-center justify-center">
          <i className="fas fa-arrow-left text-sm"></i>
        </span>
        Back to Home
      </button>
    </div>
  );
}